import { createCrudApi, toQuery } from 'src/shared/api/crudApi';
import { httpClient } from 'src/shared/api/httpClient';
import { API_PREFIX } from 'src/shared/constants';
import type {
  Client,
  ClientDetail,
  ClientListParams,
  ClientNote,
  ClientNotePayload,
  ClientPayload,
  ClientUpdatePayload,
} from './types';

const base = `${API_PREFIX}/clients`;

// The generic CRUD covers list/create/update/remove unchanged. `get` and the
// two client-specific endpoints are layered on top rather than replacing it:
// the detail route returns a richer shape than the list rows, and notes and
// merge are not CRUD at all.
const crud = createCrudApi<Client, ClientListParams, ClientPayload, ClientUpdatePayload, number>(
  base
);

export const clientsApi = {
  ...crud,

  get: (id: number) => httpClient.get<ClientDetail>(`${base}/${id}`),

  list: (params?: ClientListParams) => httpClient.list<Client>(`${base}/?${toQuery(params ?? {})}`),

  notes: (clientId: number) => httpClient.get<ClientNote[]>(`${base}/${clientId}/notes`),

  addNote: (clientId: number, data: ClientNotePayload) =>
    httpClient.post<ClientNote>(`${base}/${clientId}/notes`, data),

  /** Retires `id` and hands its history to `targetId`, which comes back. */
  merge: (id: number, targetId: number) =>
    httpClient.post<Client>(`${base}/${id}/merge`, { targetId }),
};
